<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'
import { VNotification, VBar } from '@/modules/shared/components'

const authStore = useAuthStore()
const workspaceStore = useWorkspaceStore()

// Clear any stale workspace state before (re)loading, so a previous workspace's
// data never flashes on a new page. Previously done by the layouts / old nav.
workspaceStore.reset()

const isBannerVisible = computed(
  () => workspaceStore.current.options.is_setup_mode_enabled && authStore.is_site_or_group_admin,
)

// Single owner of the workspace fetch (was duplicated across layouts + old nav).
onMounted(async () => {
  await workspaceStore.fetchCurrent()
})
</script>

<template>
  <!-- Global toasts: render once for all users and viewports -->
  <VNotification />

  <!-- Setup-mode banner -->
  <div v-if="isBannerVisible" class="fixed left-0 right-0 top-0 z-50 block bg-white/5 backdrop-blur">
    <div
      class="flex h-8 items-center justify-center bg-gradient-to-r from-violet-500 to-indigo-600 text-center text-sm font-medium text-white opacity-90"
    >
      Setup mode is enabled. Automated emails will not be sent.
    </div>
  </div>

  <!-- Top gradient accent bar (sits below the banner when it is showing) -->
  <VBar :below-banner="isBannerVisible" />
</template>
